import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71a6bad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "highscore" }
const _hoisted_2 = { class: "highscore__rank" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "highscore__name" }
const _hoisted_5 = { class: "highscore__score" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.leaderboardEntry.rank), 1),
    _createElementVNode("img", {
      class: "highscore__avatar",
      src: _ctx.avatar
    }, null, 8, _hoisted_3),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.displayName), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.score), 1)
    ])
  ]))
}